import { Component, OnInit } from '@angular/core';

import { BaseFormComponent } from '../base.form.component';

@Component({
  selector: 'app-full-name',
  templateUrl: './full-name.component.html',
  styleUrls: ['../base.form.scss']
})
export class FullNameComponent extends BaseFormComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
